import { useCallback, useState } from "react"
import { useCheckStripePaymentMethod } from "@/api/generated/endpoints/api"
import { useIsEchoesOwner } from "@/store/session"

export function usePaymentMethodRequirement() {
  const isEchoesOwner = useIsEchoesOwner()
  const [isPaymentMethodDialogOpen, setIsPaymentMethodDialogOpen] = useState(false)
  const { refetch, isFetching } = useCheckStripePaymentMethod({
    query: { enabled: false },
  })

  const ensurePaymentMethod = useCallback(async () => {
    if (isEchoesOwner) {
      return true
    }

    const result = await refetch()
    if (result.data?.hasPaymentMethod === false) {
      setIsPaymentMethodDialogOpen(true)
      return false
    }

    return true
  }, [isEchoesOwner, refetch])

  return {
    ensurePaymentMethod,
    isCheckingPaymentMethod: isFetching,
    isPaymentMethodDialogOpen,
    setIsPaymentMethodDialogOpen,
  }
}
